// generated from 15_649_444 samples

import { z } from "zod";
import { common } from "../common";

export const attachedImageSchema = z.object({
  app_group_id: common.objectId,
  // avg: 1706769618.48, min: 1439407530, max: 1749538586
  created_at: z.int().nonnegative(),
  // null: 458_606 (2.93%)
  created_by: common.objectId.nullable(),
  // Canonical values are the extensions of the persisted asset classes (see
  // MimeTypes::MIME_TYPES_BY_EXTENSION in Ruby / MEDIA_LIBRARY.UPLOADABLE_TYPES
  // in shared_constants.json). "zip" uploads are unpacked, so it is not listed.
  ext: z.enum([
    "png", // 8_062_086 (51.52%)
    "jpg", // 5_893_007 (37.66%)
    "jpeg", // 985_557 (6.30%)
    "gif", // 678_341 (4.33%)
    "css", // 10_265 (0.07%)
    "svg", // 9_811 (0.06%)
    "js", // 3_750 (0.02%)
    "otf", // 3_507 (0.02%)
    "ttf", // 1_460 (0.01%)
    "webp",
    "woff2", // 980 (0.01%)
    "woff", // 679 (0.00%)
    "vcf", // 1 (0.00%)
    "ico",
    "doc",
    "docx",
    "pdf",
    "ppt",
    "pptx",
    "xls",
    "xlsx",
    // VideoAsset (SUPPORTED_EXTENSIONS), attachable to iOS push (VALID_ASSET_FILE_TYPES)
    "mp4",
  ]),
  id: common.objectId,
  // undefined: 20_642 (0.13%), defined 15_628_802 (99.87%)
  // null: 13_928 (0.09%)
  // avg: 738.63, min: 1, max: 15845
  known_height: z.int().min(1).nullable().optional(),
  // undefined: 20_642 (0.13%), defined 15_628_802 (99.87%)
  // null: 13_928 (0.09%)
  // avg: 1032.25, min: 1, max: 15748
  known_width: z.int().min(1).nullable().optional(),
  // null: 445_432 (2.85%)
  last_edited_by: common.objectId.nullable(),
  name: z.string(),
  // undefined: 20_642 (0.13%), defined 15_628_802 (99.87%)
  // null: 13_943 (0.09%)
  // integer: 2_973_679 (19.04%)
  // avg: 2.01, min: 0.0009950248756218905, max: 1774.5
  ratio: z.number().nonnegative().nullable().optional(),
  // avg: 488751.93, min: 0, max: 230026910
  size: z.int().min(0),
  tag_names: z.array(z.string()),
  territory_ids: z.array(common.objectId),
  // Canonical values from MimeTypes::MIME_TYPES_BY_EXTENSION in Ruby, for the
  // extensions above.
  type: z.enum([
    "image/png", // 8_060_531 (51.51%)
    "image/jpg", // 6_440_463 (41.15%)
    "image/gif", // 678_470 (4.34%)
    "image/jpeg", // 439_527 (2.81%)
    "image/webp",
    "text/css", // 10_265 (0.07%)
    "image/svg+xml", // 9_811 (0.06%)
    "application/javascript", // 3_750 (0.02%)
    "font/otf", // 3_507 (0.02%)
    "font/ttf", // 1_460 (0.01%)
    "font/woff2", // 980 (0.01%)
    "font/woff", // 679 (0.00%)
    "text/x-vcard", // 1 (0.00%)
    "image/x-icon",
    "application/octet-stream",
    "application/vnd.ms-opentype",
    "application/font-woff",
    "text/javascript",
    "application/x-javascript",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    // VideoAsset#as_json video_content_type
    "video/mp4",
  ]),
  // VideoAsset#as_json emits url: nil
  url: z.string().nullable(),
});
